import { useFormContext } from "react-hook-form";
import { Badge } from "react-bootstrap";

function InfoItem({ label, value }) {
  if (!value) return null;
  return (
    <div className="d-flex flex-column" style={{ minWidth: "120px" }}>
      <span className="text-muted" style={{ fontSize: "0.7rem", lineHeight: 1.2 }}>{label}</span>
      <span style={{ fontSize: "0.85rem", fontWeight: 500 }}>{value}</span>
    </div>
  );
}

export function WeighbridgeTicketExternalDataInfo({ ticketIndex }) {
  const { getValues } = useFormContext();
  const externalData = getValues(`weighbridgeTickets[${ticketIndex}].externalData`);
  if (!externalData) {
    return null;
  }

  const {
    dateWeighFirst,
    dateWeighSecond,
    weightFirst,
    weightSecond,
    weightNet,
    contractorName,
    driverName,
    vehicleRegistrationNumber,
    wastes
  } = externalData;

  const formatWeight = (val) => val != null ? `${val} kg` : null;
  const formatDateTime = (val) => val ? new Date(val).toLocaleString("pl-PL") : null;

  return (
    <div className="rounded border border-secondary-subtle bg-light px-3 py-2 mb-2" style={{ fontSize: "0.85rem" }}>
      <div className="d-flex align-items-center gap-2 mb-2">
        <Badge bg="primary" style={{ fontSize: "0.7rem" }}>Dane z programu magazynowego</Badge>
      </div>
      <div className="d-flex flex-wrap gap-3">
        <InfoItem label="Kontrahent" value={contractorName} />
        <InfoItem label="Kierowca" value={driverName} />
        <InfoItem label="Nr rejestracyjny" value={vehicleRegistrationNumber} />
        <InfoItem label="1. ważenie" value={formatDateTime(dateWeighFirst)} />
        <InfoItem label="2. ważenie" value={formatDateTime(dateWeighSecond)} />
        <InfoItem label="Masa brutto" value={formatWeight(weightFirst)} />
        <InfoItem label="Masa tary" value={formatWeight(weightSecond)} />
        <InfoItem label="Masa netto" value={formatWeight(weightNet)} />
        {wastes?.map((waste, index) => (
          <InfoItem key={index} label={`Towar ${index + 1}`} value={`${waste.wasteCode} - ${formatWeight(waste.weightNet)}`} />
        ))}
      </div>
    </div>
  );
}
